import { type Common } from './common.js';
import {
  type EncounterSummary,
  type FindAllOptions,
  type UpdateValues,
} from './models/encounter/summary.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions): Promise<EncounterSummary[]> {
    const url = this.common.constructPath(`/encounter-summaries`, options);
    return await this.common.getJSON(url);
  }

  async get(summaryId: string): Promise<EncounterSummary> {
    const url = this.common.constructPath(`/encounter-summaries/${summaryId}`);
    return await this.common.getJSON(url);
  }

  async update(summaryId: string, values: UpdateValues) {
    const url = this.common.constructPath(`/encounter-summaries/${summaryId}`);
    return await this.common.patchJSON(url, values);
  }

  async exportToEhr(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/encounters/${encounterId}/previsit-planning/export`);
    return await this.common.postJSON(url, {});
  }

  async generateNote(encounterId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/patients/previsit-planning/start`);
    return await this.common.postJSON(url, { encounterId });
  }
}
